import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocationSettingsAction } from "../actions";
import { getLoading, getData, getTypes, getHolidayTypes, getEstablishmentTypes, getRiskCenters } from "../selectors";
import { getAppColor, getCountry } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";

const LocatiomSettings = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const types = useSelector(getTypes);
    const holidayTypes = useSelector(getHolidayTypes);
    const isLoading = useSelector(getLoading);
    const country = useSelector(getCountry);
    const establishmentTypes = useSelector(getEstablishmentTypes);
    const riskCenters = useSelector(getRiskCenters);

    useEffect(() => {
        dispatch(getLocationSettingsAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.locationSettingsBox);
    };

    return (
        <ABMLayout
            title={getLocalizedString("locationSettings")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newWorkplace")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noWorkplacesFound")}
            noDataCreateTitle={getLocalizedString("newWorkplace")}
            noDataOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem
                        color={color}
                        data={null}
                        types={types}
                        holidayTypes={holidayTypes}
                        closeNew={() => setCreateIsOpen(false)}
                        country={country}
                        establishmentTypes={establishmentTypes}
                        riskCenters={riskCenters}
                    />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.internalCode}>
                            <DataItem
                                data={item}
                                types={types}
                                color={color}
                                holidayTypes={holidayTypes}
                                country={country}
                                establishmentTypes={establishmentTypes}
                                riskCenters={riskCenters}
                            />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default LocatiomSettings;
